
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/full",
      function () {
        return require("private-next-pages/register/full/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/full"])
      });
    }
  